export interface CommissionTier {
  signups: number;
  bonus: number;
  rate: number;
}

export const COMMISSION_RATES: Record<string, CommissionTier> = {
  TIER_1: { signups: 10, bonus: 50, rate: 5.0 },
  TIER_2: { signups: 25, bonus: 150, rate: 6.0 },
  TIER_3: { signups: 50, bonus: 350, rate: 7.0 },
  ORGANIC_BONUS: { signups: 0, bonus: 0, rate: 0 }
};

export interface ReferralLink {
  id: string;
  userId: string;
  code: string;
  url: string;
  clicks: number;
  signups: number;
  conversions: number;
  createdAt: string;
}

export interface ReferralTracking {
  id: string;
  referrerId: string;
  referredUserId: string;
  status: 'clicked' | 'signed_up' | 'converted' | 'paid';
  commissionEarned?: number;
  clickedAt?: string;
  signedUpAt?: string;
  convertedAt?: string;
  paidAt?: string;
  createdAt: string;
}

export interface CommissionPayment {
  id: string;
  userId: string;
  amount: number;
  status: 'pending' | 'processing' | 'paid' | 'failed';
  paymentMethod: string;
  transactionId?: string;
  createdAt: string;
  paidAt?: string;
}

export interface InfluencerPersonalStats {
  totalClicks: number;
  totalSignups: number;
  totalConversions: number;
  totalEarnings: number;
  pendingEarnings: number;
  conversionRate: number;
}

export interface InfluencerTier {
  current: number;
  progress: number;
  nextTierRequirement: number;
}

export interface InfluencerDashboardData {
  referralLink: ReferralLink;
  personalStats: InfluencerPersonalStats;
  tier: InfluencerTier;
  paymentHistory: CommissionPayment[];
}

export interface TopPerformer {
  userId: string;
  name: string;
  email: string;
  totalReferrals: number;
  totalEarnings: number;
  conversionRate: number;
  tier: number;
}

export interface InfluencerAnalytics {
  totalInfluencers: number;
  activeInfluencers: number;
  totalCommissions: number;
  averageConversionRate: number;
  monthlyGrowth: number;
  topPerformers: TopPerformer[];
}

export interface GenerateReferralLinkRequest {
  customCode?: string;
}

export interface GenerateReferralLinkResponse {
  success: boolean;
  data?: ReferralLink;
  message?: string;
}

export interface InfluencerPerformanceResponse {
  success: boolean;
  data?: any;
  message?: string;
}

export interface AdminInfluencerAnalyticsResponse {
  success: boolean;
  data?: InfluencerAnalytics;
  message?: string;
} 